/**
* @summary - Component that Provides Work Group Creation Page
* @author Aro J
* @since 2024-06-10
*/
import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import CreateLicenseTypeCode from '../../components/licensetypecodecomponents/CreateLicenseTypeCode'

function LicenseTypeCodeRegister({renderPageContent}) {
    return (
        <>
                        <CreateLicenseTypeCode renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}

export default LicenseTypeCodeRegister;